module.exports = __webpack_public_path__ + "img/promo-modal-img.35b08f58.svg";